import React, {useEffect, useContext} from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import LandingPages from "../client_config/seo_config/landing_pages/LandingPages";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import {RouterContext} from "./Onboarding"

export default function LandingPagesOB(props) {
  const route = useContext(RouterContext)

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem(
      "routerHistory",
      JSON.stringify([...route.get])
    );
  }, [route.get]);
  props.pageLocator();
  return (
    <>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <Row className="px-lg-4 px-0  justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Landing Pages</p>
          </div>
          <div>
            <p className="f14 nunito-regular primary ">
              On this page, you can set up any landing pages that you may want to track for SEO purposes. You can set the landing page items below to track
              exact landing page URLs (like your homepage), or groups of landing pages that share a common base URL (like product pages).
            </p>
          </div>
        </Col>
      </Row>
      <Row className="pb-2">
        <Col className="center-from-right">
           <NextButton
            validated={true} 
            btnText={`Next`}
            nextPage={nextPage.url}
            invalidText={`We need more information on this page before you continue.`}
            submitForm={props.submitForm}
          />
        </Col>
      </Row>
      <div className="mx-lg-5 mx-0 tab-shadow" style={{ backgroundColor: "#F5F5F5" }}>
        <LandingPages {...props} onboarding />
      </div>
      <Row className="mt-5 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton 
              btnText={`Skip for now`}
              nextPage={nextPage.url}
            />
            <NextButton
              validated={true} 
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
